var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 64C474.746 64 464 74.746 464 88V424C464 437.254 474.746 448 488 448S512 437.254 512 424V88C512 74.746 501.254 64 488 64ZM344 64C330.746 64 320 74.746 320 88V424C320 437.254 330.746 448 344 448S368 437.254 368 424V88C368 74.746 357.254 64 344 64ZM32.217 448C39.219 448 46.361 445.695 52.506 440.594L244.529 280.621C259.781 267.748 259.781 244.252 244.529 231.379L52.506 71.406C46.361 66.307 39.217 64 32.217 64C15.713 64 0 76.809 0 96.027V415.973C0 435.189 15.715 448 32.217 448ZM48 130.127L199.094 256L48 381.875V130.127Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPause);
export default __webpack_public_path__ + "static/media/play-pause.1206d50a431a881e4ebb02d3a7cd0780.svg";
export { ForwardRef as ReactComponent };